import {
	Dialog,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton
} from "@mui/material"
import FormActionButtons from "components/ui/form/FormActionButtons"
import FormCurrencyField from "components/ui/form/FormCurrencyField"
import { useFormik } from "formik"
import useFormSubmit from "hooks/useFormSubmit"
import useAxiosPrivate from "hooks/useAxiosPrivate"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import * as yup from "yup"

const validationSchema = yup.object({
	sum: yup.number().required("settings.currency.modal.validation.sum")
})

const CurrencyAddModal = (props) => {
	const { open, setOpen, setRefetch } = props
	const { t } = useTranslation()
	const { submit, isSubmitting } = useFormSubmit()
	const axiosPrivate = useAxiosPrivate()
	const [loadingPrevious, setLoadingPrevious] = useState(true)

	const formik = useFormik({
		initialValues: {
			sum: "",
			bank_rate: "",
			secondary_rate: "",
			mortgage_limit: ""
		},
		validationSchema: validationSchema,
		onSubmit: async (values) => {
			submit(
				{ type: "post", contentType: "simple" },
				values,
				"/admin/valute",
				{
					title: t("settings.currency.modal.alerts.success")
				},
				null,
				false,
				handleFinish
			)
		}
	})

	// Modal ochilganda oxirgi kursning barcha maydonlari oldindan to'ldiriladi —
	// admin faqat o'zgargan maydonni tahrirlaydi, qolgani o'sha-o'sha saqlanadi
	useEffect(() => {
		setLoadingPrevious(true)
		axiosPrivate
			.get("admin/valute/index")
			.then((response) => {
				const last = response?.data?.data?.data?.[0]
				if (last) {
					formik.setValues({
						sum: last.sum ?? "",
						bank_rate: last.bank_rate ?? "",
						secondary_rate: last.secondary_rate ?? "",
						mortgage_limit: last.mortgage_limit ?? ""
					})
				}
			})
			.finally(() => setLoadingPrevious(false))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleFinish = () => {
		setRefetch(true)
		handleClose()
	}

	const handleClose = () => {
		setOpen(false)
		formik.resetForm()
	}

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			maxWidth="lg"
			disableEscapeKeyDown={true}
		>
			<DialogTitle id="alert-dialog-title">
				<span className="pr-5">{t("settings.currency.modal.title")}</span>
				<div className="close-btn-wrapper">
					<IconButton variant="onlyIcon" color="primary" onClick={handleClose}>
						<i className="bi bi-x" />
					</IconButton>
				</div>
			</DialogTitle>

			<DialogContent>
				<form onSubmit={formik.handleSubmit} className="pt-2">
					<Grid
						container
						spacing={{ xs: 2, sm: 2 }}
						rowSpacing={1}
						columns={{ xs: 12, sm: 12 }}
					>
						<Grid item={true} sm={12} xs={12}>
							<FormCurrencyField
								delay={0.1}
								label={t("common.fields.currencyInSum")}
								fieldName="sum"
								formik={formik}
							/>
						</Grid>

						<Grid item={true} sm={12} xs={12}>
							<FormCurrencyField
								delay={0.15}
								label={t("common.fields.bankRate")}
								fieldName="bank_rate"
								formik={formik}
							/>
						</Grid>

						<Grid item={true} sm={12} xs={12}>
							<FormCurrencyField
								delay={0.18}
								label={t("common.fields.secondaryRate")}
								fieldName="secondary_rate"
								formik={formik}
							/>
						</Grid>

						<Grid item={true} sm={12} xs={12}>
							<FormCurrencyField
								delay={0.2}
								label={t("common.fields.mortgageLimit")}
								fieldName="mortgage_limit"
								formik={formik}
							/>
						</Grid>

						<Grid item={true} sm={12} xs={12}>
							<FormActionButtons
								delay={0.2}
								isSubmitting={isSubmitting || loadingPrevious}
								formType="dialog"
								setOpen={setOpen}
								reset={formik.resetForm}
							/>
						</Grid>
					</Grid>
				</form>
			</DialogContent>
		</Dialog>
	)
}

export default CurrencyAddModal
